import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Input,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioIconName } from '@resident-nx/shared';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-details-chat-overview',
  styles: `
    span {
      color: white;
      background-color: red;
      width: 15px;
    }
  `,
  template: `
    <hr />
    <div class="d-flex align-items-start mb-2">
      <strong class="me-1 primary-text"> {{ 'ticket_chat.message_history_l' | translate }}</strong>
      @if (messageCount > 0 && !hideNewMessageCounter()) {
        <span class="title-xs d-flex align-items-center justify-content-center rounded">{{
          messageCount
        }}</span>
      }
    </div>
    <button im-button class="inverted d-block" (click)="openChat.emit()">
      <i iconStart [class]="'icon-' + icons.Chat"></i>
      {{ 'ticket_chat.open_messegner_l' | translate }}
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, TranslateModule],
})
export class TicketDetailsChatOverviewComponent {
  protected readonly icons = ImmomioIconName;
  hideNewMessageCounter = input(false);
  @Input() messageCount: number;
  @Output() openChat = new EventEmitter();
}
